import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import { Tabs } from 'antd';
import Direction from 'components/guide/Direction';
import Info from 'components/guide/Info';
import { font } from 'asserts/styles/fonts';

const Guide = () => {
  const tabDatas = [
    {
      key: '1',
      label: '이용방법',
      children: <Direction />
    },
    {
      key: '2',
      label: '검사안내',
      children: <Info />
    }
  ];

  return (
    <Wrapper>
      <InnerWraper>
        <Tabs defaultActiveKey="1" items={tabDatas} />
      </InnerWraper>
    </Wrapper>
  );
};

export default Guide;

const Wrapper = styled.div`
  margin: 0 auto;
  padding-top: 128px;
  color: ${color.navyLight};
  h2 {
    color: ${color.navyLight};
    ${font.d1_bold};
  }
`;

const InnerWraper = styled.div`
  .ant-tabs-nav {
    width: 890px;
    margin: 0 auto;
  }

  .ant-tabs-nav-list .ant-tabs-tab-btn {
    font-size: 20px;
    font-weight: 500;
  }
`;
